<template>
  <div class="bar_wrapper">
    <span class="bar active"></span>
    <span class="bar active"></span>
    <span class="bar"></span>
    <span class="bar"></span>
    <span class="bar"></span>
    <span class="bar"></span>
  </div>
  <div class="img"></div>
  <div class="question_wrapper">
    <div class="question_number">Q2</div>
    <p class="question_text">この中にニートは何人いるでしょう？</p>
  </div>
  <div class="input_container" v-on:click="next('a')">1人</div>
  <div class="input_container" v-on:click="next('b')">3人</div>
  <div class="input_container" v-on:click="next('c')">10人</div>
</template>

<script>
export default {
  name: "question2",
  methods: {
    next(input_value) {
      let point = 0;
      let is_syachiku = false;
      let normal_point = 0;

      if (input_value == "a") {
        point = -5;
      } else if (input_value == "b") {
        point = 1;
      } else if (input_value == "c") {
        point = 3;
        normal_point += 1;
      }

      this.$emit("next", point, normal_point, is_syachiku);
    },
  },
};
</script>

<style scoped>
.img {
  background-image: url("../../assets/img/question/question_2.png");
}
</style>
